import MasterCrud from "@/components/MasterCrud";
import { Warehouse } from "lucide-react";

export default function StoreMaster() {
  return (
    <MasterCrud
      endpoint="/stores"
      slug="store"
      title="Store Master"
      subtitle="Inventory · Store locations (Main Store, Godown, Branch, Workshop)"
      icon={Warehouse}
      fields={[
        ["name", "Store Name"],
        ["store_type", "Store Type", "select-static", ["Main Store", "Godown", "Branch Store", "Workshop Store"]],
        ["address", "Address"],
        ["phone", "Phone Number"],
        ["status", "Status", "select-static", ["Active", "Inactive"]],
      ]}
    />
  );
}
